export default "__VITE_ASSET__CvfoBXW7__"